import { locationsSelectors } from '@westondev/tableturn-core';

export const { selectShouldRenderLocationDropdown } = locationsSelectors;
